import {
  CommunicationVM,
  DataWizardAct,
  DocumentVM,
  LastStepVM,
  ParentVM,
  RecapVM,
  RequestsType,
  SectionVM,
  SignatureActUscVM,
  SignatureActVM,
  StepVM,
  TextActVM,
  ViewStepVM,
} from 'civil-status/view-models/step-form';
import { Fragment, memo, useMemo } from 'react';
import ActionsForm from './actions-form';
import FormRequests from './form-requests';
import LastStep from './last-step';
import RecapForm from './recap-form';
import { SectionWizardUseCase, SubjectsWizardUseCase } from 'shell/models/subjects-wizard';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import FormSignatureAct from './form-signature-act';
import FormSignatureUSC from './form-signature-usc';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import ViewStep from './view-form';
import { useFormikContext } from 'formik';
import { ID_NUMBERS_COMPARENTI } from './last-step/accordions/section/list/list-number';
import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { useEventCallback } from '@mui/material';
import { isDisabledValid } from 'civil-status/utils/is-disabled-valid';
import { formStepWithErrors } from 'civil-status/utils/form-step-with-errors';
import { KeySections, KeySubjects } from 'civil-status/constants/keys-subjects-section';
import { CommunicationRes } from 'shell/models/communications';
import { noop } from 'shell/utils/noop';

interface StepFormProps {
  idAnsc?: string;
  goBack: () => void;
  onClickNotification: (isConfirm?: boolean) => void;
  onSave: (values: StepVM) => Promise<DataWizardAct | void | undefined> | void;
  onClickRecap: (step: string, index: number) => void;
  deleteEvent: () => void;
  onSaveSubject: (values: ParentVM) => ResponsePromise<number | undefined> | void | undefined;
  onSaveSection: (values: SectionVM) => ResponsePromise<DataWizardAct> | void | undefined;
  onSaveText: (values?: TextActVM) => void;
  onClickValid: () => void;
  onClickEditAct: (values?: SectionVM) => void;
  onClickPreview: () => void;
  onYesPreview: (idAnsc?: string) => void;
  onPrintAct: () => void;
  onConfirmRegistration: () => void;
  backCompilation: (values?: SignatureActUscVM) => void;
  onClickVerify: (values?: SignatureActVM) => void | ResponsePromise<number>;
  onClickVerifyDocument: (document?: TypeFile) => void | ResponsePromise<string>;
  signatureUSC: () => void;
  getTextAct?: () => void;
  setRecap: (state: Array<RecapVM>) => void;
  onClickPrintCommunication: (communicationValues?: CommunicationVM) => void;
  onParent: (values: ViewStepVM, title?: string) => void;
  onOther: () => void;
  onCohabitation: () => void;
  onRegisterDeath: (values: ViewStepVM, isNonResidente?: boolean) => void;
  onRegisterBirth?: (values: ViewStepVM) => void;
  onRegisterCitizenship: (values: ViewStepVM, isNonResidente?: boolean) => void;
  onRegisterMarriageCivilUnion: (
    values: ViewStepVM,
    isCivilUnion?: boolean,
    isNonResidente?: boolean
  ) => void;
  goBackNotification: () => void;
  onCancelNotification: () => void;
  transcribeOath: (idEvento?: number) => void;
  onForwardCertificateConformity: (values: SignatureActUscVM) => void;
  recap?: Array<RecapVM>;
  requests?: RequestsType;
  soggettiUseCaseData?: Array<SubjectsWizardUseCase>;
  sezioniUseCaseData?: Array<SectionWizardUseCase>;
  dateFormationAct?: string;
  tipoEvento?: string;
  idUseCase?: string;
  idEvento?: number;
  idActGemelloSuccessivo?: number;
  isLastStep?: boolean;
  isLastStepEmergency?: boolean;
  isLastStepEdit?: boolean;
  isLastStepEditAct?: boolean;
  disabled?: boolean;
  isSignatureAct?: boolean;
  isSignatureUSC?: boolean;
  isView?: boolean;
  isCertificateConformity?: boolean;
  isCertificateConformityWithoutSubjects?: boolean;
  withReasonDelay?: boolean;
  isNotifications?: boolean;
  isNotificationsAnsc?: boolean;
  isCommunications?: boolean;
  isDetailAcquisitionNotifications?: boolean;
  isEditAcquisitionNotifications?: boolean;
  isStepFromEmergency?: boolean;
  isStepFromEmergencyConfirm?: boolean;
  controlsCommunications?: Array<CommunicationRes>;
  stateNotification?: string;
  idNotifica?: string;
}

const StepFormComponent = ({
  idAnsc,
  goBack,
  onClickNotification,
  onSave,
  onClickRecap,
  onSaveSubject,
  onSaveSection,
  onSaveText,
  onClickValid,
  onClickEditAct,
  onClickPreview,
  deleteEvent,
  onYesPreview,
  onPrintAct,
  onConfirmRegistration,
  backCompilation,
  onClickVerify,
  onClickVerifyDocument,
  signatureUSC,
  getTextAct,
  setRecap,
  onClickPrintCommunication,
  onParent,
  onOther,
  onCohabitation,
  onRegisterDeath,
  onRegisterCitizenship,
  onRegisterMarriageCivilUnion,
  goBackNotification,
  onCancelNotification,
  transcribeOath,
  onForwardCertificateConformity,
  recap = [],
  requests,
  soggettiUseCaseData,
  sezioniUseCaseData,
  idEvento,
  idActGemelloSuccessivo,
  dateFormationAct,
  tipoEvento,
  idUseCase,
  stateNotification,
  isLastStep = false,
  isLastStepEmergency = false,
  isLastStepEdit = false,
  isLastStepEditAct = false,
  disabled = false,
  isSignatureAct = false,
  isSignatureUSC = false,
  isCertificateConformity = false,
  isCertificateConformityWithoutSubjects = false,
  isView = false,
  withReasonDelay = false,
  isNotifications = false,
  isNotificationsAnsc = false,
  isCommunications = false,
  isDetailAcquisitionNotifications = false,
  isEditAcquisitionNotifications = false,
  isStepFromEmergency = false,
  isStepFromEmergencyConfirm = false,
  controlsCommunications,
  idNotifica,
  onRegisterBirth = noop,
}: StepFormProps): React.ReactElement => {
  const formContext = useFormikContext<LastStepVM>();

  const allValues: LastStepVM = formContext.values || {};

  // values sezione Dati morte
  const valuesDatiDecesso: SectionVM | undefined = allValues[KeySections.keyDatiDecesso];

  // nella sezione scelto 1 comparente
  const isWith1Comparente: boolean = useMemo(() => {
    return valuesDatiDecesso?.numberAppearing === ID_NUMBERS_COMPARENTI.ID_COMPARENTE1;
  }, [valuesDatiDecesso?.numberAppearing]);

  // nella sezione scelti 2 comparenti
  const isWith2Comparente: boolean = useMemo(() => {
    return valuesDatiDecesso?.numberAppearing === ID_NUMBERS_COMPARENTI.ID_COMPARENTE2;
  }, [valuesDatiDecesso?.numberAppearing]);

  // values soggetto Deceduto
  const valuesDeceduto: ParentVM | undefined = allValues[KeySubjects.keyDeceduto];

  // values sezione Dati generali di riconoscimentoList
  const valuesDatiGeneraliRiconoscimento: SectionVM | undefined = useMemo(() => {
    return allValues[KeySections.keyDatiGeneraliRiconoscimento];
  }, [allValues[KeySections.keyDatiGeneraliRiconoscimento]]);

  const withErrors: boolean = useMemo(() => {
    return formStepWithErrors(
      formContext.errors,
      isWith1Comparente,
      isWith2Comparente,
      valuesDeceduto,
      valuesDatiGeneraliRiconoscimento,
      soggettiUseCaseData
    );
  }, [
    formContext.errors,
    valuesDatiGeneraliRiconoscimento,
    isWith1Comparente,
    isWith2Comparente,
    valuesDeceduto,
    valuesDatiGeneraliRiconoscimento,
    soggettiUseCaseData,
  ]);

  const disabledValid = useMemo(() => {
    const keysValues = Object.keys(allValues);
    let keyWithTwins = '';

    keysValues.forEach((keyItem) => {
      const dataSubject = allValues[keyItem] as ParentVM;

      if (dataSubject?.generality?.isWithTwins && dataSubject?.generality?.currentTwin === 1) {
        keyWithTwins = keyItem;
      }
    });

    return isDisabledValid(isLastStep, withErrors, allValues as LastStepVM, keyWithTwins);
  }, [isLastStep, withErrors, allValues]);

  const disabledCertificateConformityWithoutAct: boolean = useMemo(() => {
    if (!isCertificateConformity && !isCertificateConformityWithoutSubjects) {
      return false;
    }
    const document = ((formContext.values || {}) as SignatureActUscVM)?.document;

    return !Boolean(document?.raw);
  }, [
    ((formContext.values || {}) as SignatureActUscVM)?.document,
    isCertificateConformity,
    isCertificateConformityWithoutSubjects,
  ]);

  const disabledForwardCertificateConformity: boolean = useMemo(() => {
    if (!isCertificateConformity && !isCertificateConformityWithoutSubjects) {
      return false;
    }
    return !(
      (((formContext.values || {}) as SignatureActUscVM)?.documentsSelected || [])?.length === 0
    );
  }, [
    ((formContext.values || {}) as SignatureActUscVM)?.documentsSelected,
    isCertificateConformity,
    isCertificateConformityWithoutSubjects,
  ]);

  const disabledEmergency: boolean = useMemo(() => {
    const keysValues = Object.keys(allValues);
    let keyWithTwins = '';

    keysValues.forEach((keyItem) => {
      const dataSubject = allValues[keyItem] as ParentVM;

      if (dataSubject?.generality?.isWithTwins && dataSubject?.generality?.currentTwin === 1) {
        keyWithTwins = keyItem;
      }
    });

    return isDisabledValid(
      isLastStep,
      withErrors,
      allValues as LastStepVM,
      keyWithTwins,
      isLastStepEmergency
    );
  }, [isLastStep, withErrors, allValues, isLastStepEmergency]);

  const disabledConfirmRegistration: boolean = useMemo(() => {
    if ((allValues['documentEmergencyAct'] as DocumentVM)?.file?.idAllegato) {
      return false;
    }

    return true;
  }, [allValues['documentEmergencyAct']]);

  const callGetTextAct = useEventCallback(
    (
      startCall?: boolean // true => se cambiamo il radio button e blocchiamo la modifica del testo
    ) => {
      const disabledButton = isLastStepEmergency ? disabledEmergency : disabledValid;
      if (
        ((!disabledButton && isLastStep && !(allValues.textAct as TextActVM)?.isEditText) ||
          startCall) &&
        getTextAct
      ) {
        // se abilitato effettuare chiamata per generare il testo dell'atto

        (
          getTextAct() as unknown as ResponsePromise<
            HttpResponse<DataWizardAct>,
            HttpResponse<DataWizardAct>
          >
        ).then((response) => {
          const castedTextAct: string =
            (response as AxiosResponse<HttpResponse<DataWizardAct>>).data.payload.evento
              ?.composizioneCompleta || '';

          formContext.setFieldValue('textAct', {
            ...(allValues.textAct || {}),
            text: castedTextAct,
            isEditText: startCall ? !allValues.textAct?.isEditText : allValues.textAct?.isEditText,
          } as TextActVM);
        });
      }
    }
  );

  const onSaveSubjectControll = useEventCallback(
    (values: ParentVM): ResponsePromise<number | undefined> | undefined => {
      return onSaveSubject(values)?.then((res) => {
        callGetTextAct();
        return res;
      }) as ResponsePromise<number | undefined> | undefined;
    }
  );

  const onSaveSectionControll = useEventCallback(
    (values: SectionVM): ResponsePromise<DataWizardAct> | void | undefined => {
      return onSaveSection(values)?.then((res) => {
        callGetTextAct();
        return res;
      }) as ResponsePromise<DataWizardAct> | void | undefined;
    }
  );

  const onSaveControll = useEventCallback(
    (values: StepVM): ResponsePromise<DataWizardAct | void | undefined> | void => {
      return onSave(values)?.then((res) => {
        callGetTextAct();
        return res;
      }) as ResponsePromise<DataWizardAct> | void | undefined;
    }
  );

  return (
    <Fragment>
      {recap.length > 0 ? (
        <RecapForm
          recap={recap}
          onClickRecap={onClickRecap}
          dateFormationAct={requests?.dateFormationAct}
        />
      ) : undefined}
      {isView ? (
        <ViewStep
          formContext={formContext}
          isCommunications={isCommunications}
          controlsCommunications={controlsCommunications}
          stateNotification={stateNotification}
          idAnsc={idAnsc}
          onPreviewByIdAnsc={onYesPreview}
        />
      ) : isLastStep ? (
        <LastStep
          formContext={formContext}
          idEvento={idEvento}
          codLastStep={
            recap[recap.length - 1]?.codStepSuccessivo || recap[recap.length - 1]?.step || undefined
          }
          onSaveSubject={onSaveSubjectControll}
          onSaveSection={onSaveSectionControll}
          callGetTextAct={callGetTextAct}
          onSaveText={onSaveText}
          soggettiUseCaseData={soggettiUseCaseData}
          sezioniUseCaseData={sezioniUseCaseData}
          disabled={disabled || (allValues.textAct as TextActVM)?.isEditText}
          dateFormationAct={dateFormationAct}
          tipoEvento={tipoEvento}
          idUseCase={idUseCase}
          withReasonDelay={withReasonDelay}
          disabledValid={disabledValid}
          disabledEmergency={disabledEmergency}
          isLastStepEditAct={isLastStepEditAct}
          isLastStepEmergency={isLastStepEmergency}
          isStepFromEmergency={isStepFromEmergency}
        />
      ) : isSignatureUSC || isCertificateConformity || isCertificateConformityWithoutSubjects ? (
        <FormSignatureUSC
          formContext={formContext}
          isCertificateConformity={
            isCertificateConformity || isCertificateConformityWithoutSubjects
          }
          idEvento={idEvento}
          disabledCertificateConformityWithoutAct={disabledCertificateConformityWithoutAct}
        />
      ) : isSignatureAct ? (
        <FormSignatureAct
          formContext={formContext}
          idEvento={idEvento}
          onYesPreview={onYesPreview}
          onClickVerifyDocument={onClickVerifyDocument}
        />
      ) : (
        <FormRequests requests={requests} disabled={disabled} />
      )}
      <ActionsForm
        formContext={formContext}
        goBack={goBack}
        onClickNotification={onClickNotification}
        onSave={onSaveControll}
        onClickValid={onClickValid}
        onClickEditAct={onClickEditAct}
        onClickPreview={onClickPreview}
        deleteEvent={deleteEvent}
        backCompilation={backCompilation}
        onClickVerify={onClickVerify}
        signatureUSC={signatureUSC}
        onYesPreview={onYesPreview}
        onPrintAct={onPrintAct}
        onConfirmRegistration={onConfirmRegistration}
        onClickPrintCommunication={onClickPrintCommunication}
        setRecap={setRecap}
        onParent={onParent}
        onRegisterBirth={onRegisterBirth}
        onOther={onOther}
        onCohabitation={onCohabitation}
        onRegisterDeath={onRegisterDeath}
        onRegisterCitizenship={onRegisterCitizenship}
        onRegisterMarriageCivilUnion={onRegisterMarriageCivilUnion}
        goBackNotification={goBackNotification}
        onCancelNotification={onCancelNotification}
        transcribeOath={transcribeOath}
        onForwardCertificateConformity={onForwardCertificateConformity}
        recap={recap}
        currentStep={requests?.step}
        isLastStep={isLastStep}
        isLastStepEmergency={isLastStepEmergency}
        isLastStepEdit={isLastStepEdit}
        isSignatureAct={isSignatureAct}
        isSignatureUSC={isSignatureUSC}
        isView={isView}
        isCertificateConformity={isCertificateConformity}
        isCertificateConformityWithoutSubjects={isCertificateConformityWithoutSubjects}
        isNotifications={isNotifications}
        isNotificationsAnsc={isNotificationsAnsc}
        isCommunications={isCommunications}
        isDetailAcquisitionNotifications={isDetailAcquisitionNotifications}
        isEditAcquisitionNotifications={isEditAcquisitionNotifications}
        isStepFromEmergency={isStepFromEmergency}
        isStepFromEmergencyConfirm={isStepFromEmergencyConfirm}
        isLastStepEditAct={isLastStepEditAct}
        disabled={disabled}
        withErrors={withErrors}
        disabledValid={disabledValid}
        disabledEmergency={disabledEmergency}
        disabledConfirmRegistration={disabledConfirmRegistration}
        disabledCertificateConformityWithoutAct={disabledCertificateConformityWithoutAct}
        disabledForwardCertificateConformity={disabledForwardCertificateConformity}
        idActGemelloSuccessivo={idActGemelloSuccessivo}
        idEvento={idEvento}
        tipoEvento={tipoEvento}
        stateNotification={stateNotification}
        idNotifica={idNotifica}
      />
    </Fragment>
  );
};

StepFormComponent.displayName = 'Step Form Component';

const StepForm = memo(StepFormComponent);

export default StepForm;
